import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Chart, registerables } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import axios from 'src/app/Service/axios';
import momentJalaali from 'moment-jalaali';

Chart.register(...registerables);
Chart.register(zoomPlugin);

interface GeneratorSummary {
  strName: string;
  strModel: string;
  strBrand: string;
  AvgLoadPercentage: number;
  AvgPowerFactor: number;
  TotalFuelConsumed: number;
  TotalEnergyProduced: number;
}

@Component({
  selector: 'app-load-watch-dashboard-periodic-analysis',
  templateUrl: './load-watch-dashboard-periodic-analysis.component.html',
  styleUrls: ['./load-watch-dashboard-periodic-analysis.component.css']
})

export class LoadWatchDashboardPeriodicAnalysisComponent implements OnInit, OnDestroy {
  summaryData: GeneratorSummary[] = [];

  fuelChartInstance: any = null;
  energyChartInstance: any = null;

  searchForm: FormGroup = this._formBuilder.group({
    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session') || '')),
    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID') || '')),
    strSDate: new FormControl(momentJalaali().subtract(30, 'day').format('jYYYY/jMM/jDD')),
    strEDate: new FormControl(momentJalaali().subtract(1, 'day').format('jYYYY/jMM/jDD')),
  });

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.fetchData();
  }

  ngOnDestroy(): void {
    if (this.fuelChartInstance) this.fuelChartInstance.destroy();
    if (this.energyChartInstance) this.energyChartInstance.destroy();
  }

  fetchData = async (showLoading: boolean = true) => {
    const model = this._other.stringNumberToNumber(this.searchForm.value);

    if (showLoading) {
      this._other.Showspinner();
    }

    try {
      let resData = (await axios.post(`LoadWatchs_Reports_Analytics`, model)).data;

      let res = typeof resData === 'string' ? JSON.parse(resData) : resData;

      this._other.nonespinner();

      if (res.ISSessionExpired == true) {
        this._tooltip.showError('لطفا وارد سیستم شوید');
        this._other.removeLocalStorage();
        this._router.navigate(['login'], { queryParams: { error: '3' } });
        return;
      }

      if (res.iResult === 0) {
        return this._tooltip.showError(res.strError || 'خطا در دریافت اطلاعات');
      }

      const fuelTable = res.Table || [];
      const energyTable = res.Table1 || [];
      this.summaryData = res.Table2 || [];

      this.updateCharts(fuelTable, energyTable);

    } catch (error) {
      this._other.nonespinner();
      this._tooltip.showError('خطا در ارتباط با سرور');
    }
  }

  updateCharts(fuelData: any[], energyData: any[]) {
    const fuelLabels = fuelData.map(r => new Date(r.ReportDate).toLocaleDateString('fa-IR-u-nu-latn'));
    const fuelValues = fuelData.map(r => r.TotalFuelConsumed);

    const energyLabels = energyData.map(r => new Date(r.ReportDate).toLocaleDateString('fa-IR-u-nu-latn'));
    const energyValues = energyData.map(r => r.TotalEnergyProduced);

    if (!this.fuelChartInstance) {
      const ctx = (document.getElementById('fuelChart') as HTMLCanvasElement).getContext('2d');
      if (ctx) {
        this.fuelChartInstance = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: fuelLabels,
            datasets: [{
              label: 'مصرف سوخت (لیتر)',
              data: fuelValues,
              backgroundColor: 'rgba(255, 183, 77, 0.7)'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { labels: { color: '#b0bec5', font: { family: 'vazir' } } } },
            scales: {
              x: { ticks: { color: '#78909c' } },
              y: { ticks: { color: '#78909c' } }
            }
          }
        });
      }
    } else {
      this.fuelChartInstance.data.labels = fuelLabels;
      this.fuelChartInstance.data.datasets[0].data = fuelValues;
      this.fuelChartInstance.update();
    }

    if (!this.energyChartInstance) {
      const ctx = (document.getElementById('energyChart') as HTMLCanvasElement).getContext('2d');
      if (ctx) {
        this.energyChartInstance = new Chart(ctx, {
          type: 'line',
          data: {
            labels: energyLabels,
            datasets: [{
              label: 'انرژی تولیدی (kWh)',
              data: energyValues,
              borderColor: '#4fc3f7',
              backgroundColor: 'rgba(79, 195, 247, 0.2)',
              fill: true,
              tension: 0.4
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { labels: { color: '#b0bec5', font: { family: 'vazir' } } } },
            scales: {
              x: { ticks: { color: '#78909c' } },
              y: { ticks: { color: '#78909c' } }
            }
          }
        });
      }
    } else {
      this.energyChartInstance.data.labels = energyLabels;
      this.energyChartInstance.data.datasets[0].data = energyValues;
      this.energyChartInstance.update();
    }
  }

  formatNumber(num: number | undefined | null, digits = 2): string {
    if (num === undefined || num === null || isNaN(num)) return '۰';
    return Number(num).toFixed(digits);
  }

}
